<template>
  <router-view
    class="sc-element page"
  />
</template>

<script>
export default {
  mounted() {
    // eslint-disable-next-line no-console
    console.log("nonsc-layout")
  },
}
</script>

<style
  lang="css" scoped src="../../assets/styles/sc-element.css">
</style>
